import React from 'react'
import './Ustav.css'
import img1 from './images/ustav img/1.png'
import img2 from './images/ustav img/2.png'
import img3 from './images/ustav img/3.png'
import img4 from './images/ustav img/4.png'
import img5 from './images/ustav img/5.png'
import img6 from './images/ustav img/6.png'
import img7 from './images/ustav img/7.png'
import img8 from './images/ustav img/8.png'
import img9 from './images/ustav img/9.png'
import img10 from './images/ustav img/10.png'
import img11 from './images/ustav img/11.png'
import ustav from './ustav.pdf'
import aktualno from './files/Aktualno Sastoqnie/Актуално Българе - 26 г.jpg'
import aktualno1 from './Aktualno.pdf'
import pic1 from './images/reshenie/Решение ПП Бълагре_2e1c9192-fa23-4b05-9aa3-91d177674537-page-001.jpg'
import pic2 from './images/reshenie/Решение ПП Бълагре_2e1c9192-fa23-4b05-9aa3-91d177674537-page-002.jpg'
import pic3 from './images/reshenie/Решение ПП Бълагре_2e1c9192-fa23-4b05-9aa3-91d177674537-page-003.jpg'
import reshenie from './reshenie.pdf'

function Ustav() {
  return (
    <div className='container'>
        <div className='layout'>
            <div className='title'>УСТАВ</div>
            <div className='gallery'>
                <div ><img className='ustav-img' src={img1} alt='pic'/></div>
                <div ><img className='ustav-img' src={img2} alt='pic'/></div>
                <div ><img className='ustav-img' src={img3} alt='pic'/></div>
                <div ><img className='ustav-img' src={img4} alt='pic'/></div>
                <div ><img className='ustav-img' src={img5} alt='pic'/></div>
                <div ><img className='ustav-img' src={img6} alt='pic'/></div>
                <div ><img className='ustav-img' src={img7} alt='pic'/></div>
                <div ><img className='ustav-img' src={img8} alt='pic'/></div>
                <div ><img className='ustav-img' src={img9} alt='pic'/></div>
                <div ><img className='ustav-img' src={img10} alt='pic'/></div>
                <div ><img className='ustav-img' src={img11} alt='pic'/></div>
            </div>
            <a className="download-button" href={ustav} download="Устав НПП - Българе.pdf">Свали Устав</a>

            <div className='title'>Актуално Състояние от 05.02.2026</div>
            <div ><img className='ustav-img' src={aktualno} alt='pic'/></div>
            <a className="download-button" href={aktualno1} download="Актуално Състояние от 05.02.2026.pdf">Свали Актуално Състояние от 05.02.2026</a>

            <div className='title'>Решение за вписване на промени в персоналня състав на изпълнителния съвет и контролния съвет, както и представителството на политическа партия "БЪЛГАРЕ"</div>

            <div className='gallery'>
                <div ><img className='ustav-img' src={pic1} alt='pic'/></div>
                <div ><img className='ustav-img' src={pic2} alt='pic'/></div>
                <div ><img className='ustav-img' src={pic3} alt='pic'/></div>
            </div>
            <a className="download-button" href={reshenie} download="Решение за вписване НПП БЪЛГАРЕ.pdf">Свали Решението</a>
        </div>
    </div>
  )
}

export default Ustav